import React from 'react';
import logo from '../assets/westcounty-mark.png';
import { content, socialLinks } from '../config/site.js';

function DiscordIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M19.54 5.22A17.46 17.46 0 0 0 15.35 3.9a.08.08 0 0 0-.09.04c-.18.33-.38.76-.52 1.1a16.2 16.2 0 0 0-4.88 0c-.14-.35-.35-.77-.53-1.1a.09.09 0 0 0-.09-.04 17.38 17.38 0 0 0-4.19 1.32.08.08 0 0 0-.04.03C2.35 9.1 1.62 12.86 1.98 16.57c0 .02.02.05.04.06a17.62 17.62 0 0 0 5.14 2.59.09.09 0 0 0 .1-.03c.4-.54.75-1.11 1.06-1.72a.08.08 0 0 0-.05-.11 11.6 11.6 0 0 1-1.62-.77.08.08 0 0 1 0-.14l.32-.25a.08.08 0 0 1 .09 0 12.55 12.55 0 0 0 10.9 0 .08.08 0 0 1 .09 0l.32.25a.08.08 0 0 1 0 .14c-.52.3-1.06.56-1.63.77a.08.08 0 0 0-.04.11c.31.61.67 1.18 1.06 1.72.02.03.06.04.1.03A17.56 17.56 0 0 0 23 16.63a.09.09 0 0 0 .04-.06c.43-4.29-.72-8.01-3.46-11.32a.07.07 0 0 0-.04-.03ZM8.69 14.31c-1 0-1.82-.92-1.82-2.04s.8-2.04 1.82-2.04c1.02 0 1.84.93 1.82 2.04 0 1.12-.8 2.04-1.82 2.04Zm6.63 0c-1 0-1.82-.92-1.82-2.04s.8-2.04 1.82-2.04c1.02 0 1.84.93 1.82 2.04 0 1.12-.8 2.04-1.82 2.04Z" />
    </svg>
  );
}

function TikTokIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M16.75 2.5c.38 3.09 2.16 4.93 4.75 5.12v3.42c-1.5.14-2.82-.34-4.63-1.45v6.43c0 8.17-8.9 10.72-12.48 4.87-2.3-3.76-.89-10.36 6.49-10.63v3.61c-.49.08-1.01.2-1.49.36-1.43.48-2.24 1.38-2.01 2.97.44 3.05 6.03 3.95 5.56-2.01V2.5h3.81Z" />
    </svg>
  );
}

export default function Footer({ lang }) {
  const t = content[lang].footer;

  return (
    <footer className="footer reveal">
      <div className="footer-main">
        <a className="footer-brand" href="/">
          <img src={logo} alt="GTA:WestCounty" />
          <span>GTA:WestCounty</span>
        </a>
        <p>{t.text}</p>
      </div>

      <div className="footer-socials" aria-label={t.socialTitle}>
        <div className="social-heading">
          <strong>{t.socialTitle}</strong>
          <span>{t.socialText}</span>
        </div>

        <div className="social-grid">
          <a className="social-card discord" href={socialLinks.discord} target="_blank" rel="noreferrer">
            <span className="social-icon"><DiscordIcon /></span>
            <span>
              <b>{t.discord}</b>
              <small>{t.discordText}</small>
            </span>
          </a>

          <a className="social-card tiktok" href={socialLinks.tiktok} target="_blank" rel="noreferrer">
            <span className="social-icon"><TikTokIcon /></span>
            <span>
              <b>{t.tiktok}</b>
              <small>{t.tiktokText}</small>
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
}
